import "./App.css";
import Navbar from "./view/Navbar";
import Body from "./view/Body";
import Footer from "./view/Footer";

function App() {
  return (
    <div className="App">
      <Navbar></Navbar>
      <Body></Body>
      <Footer></Footer>
    </div>
  );
}

export default App;
